var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fetcher } from "../fetcher/index.js";
import { execute } from "../lang/execute/index.js";
import { createMod } from "../lang/mod/createMod.js";
import {} from "../lang/mod/index.js";
import { parseStmts } from "../lang/syntax/index.js";
export class Loader {
    constructor(options) {
        this.loaded = new Map();
        this.loading = new Set();
        this.onOutput = (output) => {
            console.log(output);
        };
        this.fetcher = options.fetcher;
    }
    load(url, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const found = this.loaded.get(url.href);
            if (found !== undefined)
                return found;
            const text = (options === null || options === void 0 ? void 0 : options.text) === undefined
                ? yield this.fetcher.fetchText(url)
                : options.text;
            const stmts = parseStmts(text);
            const mod = createMod({
                loader: this,
                url,
                text,
                stmts,
            });
            this.loading.add(url.href);
            for (const stmt of stmts) {
                yield execute(mod, stmt);
            }
            this.loading.delete(url.href);
            this.loaded.set(url.href, mod);
            return mod;
        });
    }
}
//# sourceMappingURL=Loader.js.map